import { render, staticRenderFns } from "./GoodsYd.vue?vue&type=template&id=2a8fed3b"
import script from "./GoodsYd.vue?vue&type=script&lang=js"
export * from "./GoodsYd.vue?vue&type=script&lang=js"
import style0 from "./GoodsYd.vue?vue&type=style&index=0&id=2a8fed3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports